import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import buttonStyle from '../utils/buttonStyle';

export default styled(Link)`
  ${props => buttonStyle(props)};
`;
